<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="31.218" height="25.213" viewBox="0 0 31.218 25.213">
		<g id="Group_45778" data-name="Group 45778" transform="translate(-1184.4 -328.97)">
			<g id="Group_44561" data-name="Group 44561" transform="translate(1180.882 324.971)">
				<g id="Group_45779" data-name="Group 45779" transform="translate(0 0)">
					<g id="Group_45785" data-name="Group 45785" transform="translate(-1.866)">
						<path
							id="Path_30415"
							data-name="Path 30415"
							d="M6.931,24A7.057,7.057,0,0,1,0,16.823,7.168,7.168,0,0,1,4.761,9.989,8.372,8.372,0,0,1,11.141.157,8.071,8.071,0,0,1,20.5,6.269a4.583,4.583,0,0,1,5.817,3.074,4.974,4.974,0,0,1-.035,3.07,6.061,6.061,0,0,1,3.332,7.734A5.783,5.783,0,0,1,24.238,24Z"
							transform="translate(5.984 4.611)"
							fill="none"
							stroke="#5f8ff2"
							stroke-linejoin="round"
							stroke-width="1.2"
						/>
						<g id="Group_45782" data-name="Group 45782" transform="translate(15.87 13.796)">
							<g id="Group_45783" data-name="Group 45783" transform="translate(0 0)">
								<g id="Group_45784" data-name="Group 45784">
									<line
										id="Line_1463"
										data-name="Line 1463"
										y2="9.834"
										transform="translate(4.393 0.074)"
										fill="none"
										stroke="#5f8ff3"
										stroke-linecap="round"
										stroke-width="1.2"
									/>
									<path
										id="Path_30418"
										data-name="Path 30418"
										d="M.5,4.754,4.234.789a.881.881,0,0,1,.3-.214A.9.9,0,0,1,5.552.789L9.285,4.754"
										transform="translate(-0.5 -0.5)"
										fill="none"
										stroke="#5f8ff3"
										stroke-linecap="round"
										stroke-width="1.2"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'FileInputSvg',
};
</script>
